import { orUndefined } from '@aloft/toolkit-shared';

import { extractAdjustmentDescription } from './extractAdjustmentDescription.ts';

export function extractQuality(sale: Element): number | undefined {
  try {
    return orUndefined(parseQualityRating)(extractAdjustmentDescription(sale, 'Quality'));
  } catch (e: unknown) {
    console.warn('Failed to parse quality', e);
    return undefined;
  }
}

function parseQualityRating(quality: string): number {
  switch (quality?.trim().toUpperCase()) {
    case 'Q1':
      return 1;
    case 'Q2':
      return 2;
    case 'Q3':
      return 3;
    case 'Q4':
      return 4;
    case 'Q5':
      return 5;
    case 'Q6':
      return 6;
    default:
      throw new Error(`Invalid quality provided: ${quality}`);
  }
}
